export function FontOutline(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
			width="1em"
			height="1em"
			{...props}
		>
			<path
				fill="currentColor"
				d="M145.569 399.818c.732 27.217 3.468 34.081 37.52 36.527v20.732H61.654v-20.732c34.052-2.446 37.792-9.31 38.524-36.527l-.022-169.31c-56.744-1.92-66.1 10.1-74.69 49.172H0c4.936-22.375 9.824-43.73 9.824-74.393H235.9c0 30.664 2.469 52.018 7.405 74.393H218.35c-8.59-39.072-16.038-51.092-72.782-49.173zm237.546-5.153c.833 21.807 11.216 35.575 50.003 37.534v24.879H282.343v-24.879c38.786-1.96 48.237-15.728 49.07-37.535l-.025-306.284c-72.995-1.738-93.062 6.565-99.274 56.01h-29.61c6.341-25.487 5.36-54.54 5.36-89.466h294.623c0 34.927 3.171 63.98 9.513 89.465h-32.06c-11.037-44.504-32.192-58.196-96.825-56.01z"
			></path>
		</svg>
	);
}
